import moment from 'moment';

function getCompanyTypes(input) {
	// { label: 'Total Industry', value: '1' },
	// { label: 'General Insurance', value: '2' },
	// { label: 'Life Insurance', value: '3' },
	// { label: 'Micro Insurance', value: '4' },
	// { label: 'ReInsurance', value: '5' },

	const totalIndustryTypes = ['GENERAL_INSURANCE', 'LIFE_INSURANCE', 'MICRO_INSURANCE'];

	if (input === '1') {
		return totalIndustryTypes;
	} else if (input === '2') {
		return ['GENERAL_INSURANCE'];
	} else if (input === '3') {
		return ['LIFE_INSURANCE'];
	} else if (input === '4') {
		return ['MICRO_INSURANCE'];
	} else if (input === '5') {
		return ['REINSURANCE'];
	}
	return totalIndustryTypes;
}

function getFilterTitle(input) {
	// { label: 'Total Industry', value: '1' },
	// { label: 'General Insurance', value: '2' },
	// { label: 'Life Insurance', value: '3' },
	// { label: 'Micro Insurance', value: '4' },
	// { label: 'ReInsurance', value: '5' },

	if (input === '1') {
		return 'Total Industry';
	} else if (input === '2') {
		return 'General Insurance';
	} else if (input === '3') {
		return 'Life Insurance';
	} else if (input === '4') {
		return 'Micro Insurance';
	} else if (input === '5') {
		return 'ReInsurance';
	}
	return 'Total Industry';
}

function getYear(input) {
	moment.locale('en-gb');
	return parseInt(input ? input : moment().format('YYYY'));
}

export { getCompanyTypes, getFilterTitle, getYear };
